<form [formGroup]="employeeForm" (ngSubmit)="onSubmit()">
  <div class="employees">
    @if (!loading()) {
      @if (!viewOnly) {
        <nav class="breadcrumb-nav" aria-label="breadcrumb">
          <div class="breadcrumb-container">
            <a routerLink="/" class="breadcrumb-link">Home</a>
            @for (item of breadcrumbItems(); track $index) {
              <lib-svg-icon [svgName]="chevronRightIcon" class="breadcrumb-chevron" [svgHeight]="'15px'" [svgWidth]="'11px'"></lib-svg-icon>
              @if (item.route) {
                <a [routerLink]="[item.route]" class="breadcrumb-link">{{ item.label }}</a>
              } @else if (item.action) {
                <a tabindex="0" (keyup.enter)="item.action()" (click)="item.action()" class="breadcrumb-link">
                  {{ item.label }}
                </a>
              } @else {
                <span class="current-page">{{ item.label }}</span>
              }
            }
          </div>
        </nav>
      }
    }

    <div class="employees__header-label-container gap-4">
      <span class="employees__main-header-label navy-text">
        <b>{{getHeaderLabel}}</b>
      </span>
    </div>
    <div class="employees__container flex gap-6">
      <div class="employees__card" [class.transparent-background]="!employeeData().employeeType">
        @if (loading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        @if (!loading()) {
          @if (!employeeData().employeeType) {
            <div class="employees__type-selector-container">
              <div class="employees__type-selector">
                <lib-svg-icon [svgName]="tutorSVG" [svgHeight]="'211px'" [svgWidth]="'211px'"></lib-svg-icon>
                <button type="button" class="overlay" aria-label="Select Tutor" (click)="onSelectType(tutorType)"></button>
              </div>
              <div class="employees__type-selector">
                <lib-svg-icon [svgName]="therapySVG" [svgHeight]="'211px'" [svgWidth]="'211px'"></lib-svg-icon>
                <button type="button" class="overlay" aria-label="Select Therapy"
                        (click)="onSelectType(therapyType)"></button>
              </div>
              <div class="employees__type-selector">
                <lib-svg-icon [svgName]="transportationSVG" [svgHeight]="'211px'" [svgWidth]="'211px'"></lib-svg-icon>
                <button type="button" class="overlay" aria-label="Select Transportation"
                        (click)="onSelectType(transportationType)"></button>
              </div>
            </div>
          }
          @if (employeeData().employeeType) {
            @if (!loading()) {
              <span class="employees__header-label navy-text"> Employee Details </span>
            }
            <div formArrayName="details">
              @for (detail of details.controls; track detail; let i = $index) {
                <div [formGroupName]="i">
                  @if (employeeData().employeeType === tutorType || employeeData().employeeType === therapyType) {
                    <div class="owner-checkbox-wrapper">
                      <span>Mark as Owner</span>
                      <mat-checkbox [attr.id]="'isOwner-' + i" formControlName="isOwner"
                                    [attr.aria-describedby]="detail.get('isOwner')?.invalid && detail.get('isOwner')?.touched ? getFieldErrorId('isOwner', i) : null">
                      </mat-checkbox>
                    </div>
                  }
                  <div class="employees__card-content employees__double-column mt-1">
                    <div class="employees__input-field">
                      <div class="user-record-field-wrapper">
                        <label [attr.for]="'firstName-' + i" class="field-label">First Name</label>
                        <mat-form-field class="provider-fields">
                          <input [attr.id]="'firstName-' + i" matInput type="text" class="user-record-field-input"
                                 formControlName="firstName"
                                 [attr.aria-describedby]="detail.get('firstName')?.invalid && detail.get('firstName')?.touched ? getFieldErrorId('firstName', i) : null" />
                        </mat-form-field>
                        <div [id]="getFieldErrorId('firstName', i)">
                          <cfi-form-inline-error [control]="detail.get('firstName')" />
                        </div>
                      </div>
                    </div>
                    <div class="employees__input-field">
                      <div class="user-record-field-wrapper">
                        <label [attr.for]="'lastName-' + i" class="field-label">Last Name</label>
                        <mat-form-field class="provider-fields">
                          <input [attr.id]="'lastName-' + i" matInput type="text" class="user-record-field-input"
                                 formControlName="lastName"
                                 [attr.aria-describedby]="detail.get('lastName')?.invalid ? getFieldErrorId('lastName', i) : null" />
                        </mat-form-field>
                        <div [id]="getFieldErrorId('lastName', i)">
                          <cfi-form-inline-error [control]="detail.get('lastName')" />
                        </div>
                      </div>
                    </div>
                    <div class="employees__input-field" [class]="{'half-width': employeeData().employeeType === transportationType, 'quarter-width': employeeData().employeeType !== transportationType}">
                      <div class="user-record-field-wrapper">
                        <label [attr.for]="'email-' + i" class="field-label">Email Address</label>
                        <mat-form-field class="provider-fields">
                          <input [attr.id]="'email-' + i" matInput type="email" class="user-record-field-input"
                                 formControlName="email" required
                                 [attr.aria-describedby]="detail.get('email')?.invalid ? getFieldErrorId('email', i) : null" />
                        </mat-form-field>
                        <div [id]="getFieldErrorId('email', i)">
                          <cfi-form-inline-error [control]="detail.get('email')" />
                        </div>
                      </div>
                    </div>
                    @if (employeeData().employeeType === tutorType || employeeData().employeeType === therapyType) {
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'birthDate-' + i" class="field-label">Date of Birth</label>
                          <mat-form-field class="provider-fields">
                            <div class="user-record-datepicker-wrapper">
                              <input [attr.id]="'birthDate-' + i" matInput [matDatepicker]="picker1" [min]="minRealisticDate"
                                     placeholder="MM/DD/YYYY" class="user-record-field-input" formControlName="birthDate"
                                     [attr.aria-describedby]="getFieldErrorId('birthDate', i)" readonly (click)="picker1.open()" />
                              <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                              <mat-datepicker #picker1></mat-datepicker>
                            </div>
                          </mat-form-field>
                          <div [id]="getFieldErrorId('birthDate', i)">
                            <cfi-form-inline-error [control]="detail.get('birthDate')" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'socialSecurityLast4-' + i" class="field-label">Social Security Number</label>
                          <lib-ssn-field [control]="getSocialSecurityControl(detail)" id="socialSecurityLast4"
                                         [editable]="!!selectedId"
                                         [ariaErrorId]="detail.get('socialSecurityLast4')?.invalid && detail.get('socialSecurityLast4')?.touched ? 'socialSecurityLast4-error' : null">
                          </lib-ssn-field>
                          <div [id]="getFieldErrorId('socialSecurityLast4', i)">
                            <cfi-form-inline-error [control]="detail.get('socialSecurityLast4')" />
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  @if (employeeData().employeeType === tutorType || employeeData().employeeType === therapyType) {
                    <div formGroupName="address" class="employees__card-content employees__double-column">
                      <div class="employees__input-field">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'streetAddress-' + i" class="field-label">Street Address</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'streetAddress-' + i" matInput type="text" class="user-record-field-input"
                                   formControlName="address1" placeholder="123 Main Street">
                          </mat-form-field>
                          <div [id]="getFieldErrorId('address1', i)">
                            <cfi-form-inline-error [control]="detail.get('address')?.get('address1') ?? null" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'city-' + i" class="field-label">City</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'city-' + i" matInput type="text" class="user-record-field-input"
                                   formControlName="city" placeholder="City">
                          </mat-form-field>
                          <div [id]="getFieldErrorId('city', i)">
                            <cfi-form-inline-error [control]="detail.get('address')?.get('city') ?? null" [customErrorMessages]="cityErrorMessages" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'state-' + i" class="field-label">State</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'state-' + i" matInput type="text" placeholder="State"
                                    class="user-record-field-input" formControlName="state" [matAutocomplete]="stateAddressAuto" />
                              <mat-autocomplete #stateAddressAuto="matAutocomplete" [displayWith]="displayState">
                                @for (state of filteredStates | async; track state) {
                                  <mat-option [value]="state">{{ state.name }}</mat-option>
                                }
                              </mat-autocomplete>
                          </mat-form-field>
                          <div [id]="getFieldErrorId('state', i)">
                            <cfi-form-inline-error [control]="detail.get('address')?.get('state') ?? null" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'zipcode-' + i" class="field-label">Zip Code</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'zipcode-' + i" matInput type="text" class="user-record-field-input"
                                   formControlName="zipcode" placeholder="Zip Code">
                          </mat-form-field>
                          <div [id]="getFieldErrorId('zipcode', i)">
                            <cfi-form-inline-error [control]="detail.get('address')?.get('zipcode') ?? null" />
                          </div>
                        </div>
                      </div>

                      @if (isNorthCarolina()) {
                        <div class="employees__input-field quarter-width">
                          <div class="user-record-field-wrapper">
                            <label [attr.for]="'county-' + i" class="field-label">County</label>
                            <mat-form-field class="provider-fields">
                              <input [attr.id]="'county-' + i" matInput type="text" placeholder="County"
                                    class="user-record-field-input" formControlName="county" [matAutocomplete]="countyAuto" />
                              <mat-autocomplete #countyAuto="matAutocomplete">
                                @for (county of filteredCounties | async; track county.name) {
                                  <mat-option [value]="county.name">{{ county.name }}</mat-option>
                                }
                              </mat-autocomplete>
                            </mat-form-field>
                            <div [id]="getFieldErrorId('county', i)">
                              <cfi-form-inline-error [control]="detail.get('address')?.get('county') ?? null" />
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            @if (employeeData().employeeType === tutorType) {
              @if (!loading()) {
                <span class="employees__header-label navy-text">
                  List the college or university this employee graduated from
                </span>
              }
              <div formArrayName="details">
                @for (detail of details.controls; track detail; let i = $index) {
                  <div [formGroupName]="i" class="employees__card-content employees__double-column">
                    <div class="employees__input-field full-width">
                      <div class="user-record-field-wrapper">
                        <label [attr.for]="'schoolCtrl-' + i" class="field-label">School Name / Code</label>
                        <mat-form-field class="provider-fields">
                          <input [attr.id]="'schoolCtrl-' + i" matInput type="text" placeholder="Search school name or code"
                                 class="user-record-field-input" formControlName="schoolCtrl" [matAutocomplete]="schoolAuto"
                                [attr.aria-describedby]="detail.get('schoolCtrl')?.invalid && detail.get('schoolCtrl')?.touched ? getFieldErrorId('schoolCtrl', i) : null" />
                          <mat-autocomplete #schoolAuto="matAutocomplete" [displayWith]="displaySchool">
                            @for (school of filteredSchools | async; track school.id) {
                              <mat-option [value]="school">
                                {{school.schoolCode}} - {{school.schoolName}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                        <div [id]="getFieldErrorId('schoolCtrl', i)">
                          <cfi-form-inline-error [control]="detail.get('schoolCtrl')" />
                        </div>
                      </div>
                    </div>
                    <div class="employees__input-field quarter-width">
                      <div class="user-record-field-wrapper">
                        <label [attr.for]="'graduationDate-' + i" class="field-label">Graduation Dates</label>
                        <mat-form-field class="provider-fields">
                          <div class="user-record-datepicker-wrapper">
                            <input class="user-record-field-input" formControlName="graduationDate" matInput
                                   placeholder="MM/DD/YYYY" readonly [attr.aria-describedby]="getFieldErrorId('graduationDate', i)"
                                   [attr.id]="'graduationDate-' + i" [matDatepicker]="picker2" [min]="minRealisticDate"
                                   (click)="picker2.open()" />
                            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                          </div>
                        </mat-form-field>
                        <div [id]="getFieldErrorId('graduationDate', i)">
                          <cfi-form-inline-error [control]="detail.get('graduationDate')" />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @if (employeeData().employeeType === tutorType || employeeData().employeeType === therapyType) {
              @if (!loading()) {
                <span class="employees__header-label navy-text">
                  Services
                </span>
              }
              <div formArrayName="details">
                @for (detail of details.controls; track $index) {
                  <div [formGroupName]="$index" class="employees__card-content employees__double-column">
                    <div class="employees__input-field" [class.full-width]="employeeData().employeeType === tutorType"
                         [class.half-width]="employeeData().employeeType === therapyType">
                      <div class="user-record-field-wrapper user-record-dropdown-wrapper">
                        <label [attr.for]="'subServices-' + $index" class="field-label">
                          {{ employeeData().employeeType === tutorType ? 'Subject Area(s)' : 'Select Sub-service' }}
                        </label>
                        <mat-form-field class="provider-fields-select">
                          <mat-select [attr.id]="'subServices-' + $index"
                                      [multiple]="employeeData().employeeType !== therapyType" formControlName="subServices"
                                        [placeholder]="employeeData().employeeType === tutorType ? 'Select Subject Area(s)' : 'Select Sub-service'"
                                      [attr.aria-describedby]="detail.get('subServices')?.invalid && detail.get('subServices')?.touched ? getFieldErrorId('subServices', $index) : null">
                            @for (service of subServices(); track service) {
                              <mat-option [value]="service">
                                {{service.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <div [id]="getFieldErrorId('subServices')">
                          <cfi-form-inline-error [control]="detail.get('subServices')" />
                        </div>
                      </div>
                    </div>
                    
                    @if (employeeData().employeeType === therapyType) {
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'npiNumber-' + $index" class="field-label">NPI Number</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'npiNumber-' + $index" matInput type="text" inputmode="numeric" maxlength="10"
                                   placeholder="1234567890" class="user-record-field-input" formControlName="npiNumber"
                                   [attr.aria-describedby]="detail.get('npiNumber')?.invalid && detail.get('npiNumber')?.touched ? getFieldErrorId('npiNumber', $index) : null" />
                          </mat-form-field>
                          <div [id]="getFieldErrorId('npiNumber')">
                            <cfi-form-inline-error [control]="detail.get('npiNumber')" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'npiNumber2-' + $index" class="field-label">NPI 2 Number</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'npiNumber2-' + $index" matInput type="text" inputmode="numeric" maxlength="10"
                                    placeholder="1234567890" class="user-record-field-input" formControlName="npiNumber2"
                                    [attr.aria-describedby]="detail.get('npiNumber2')?.invalid && detail.get('npiNumber2')?.touched ? getFieldErrorId('npiNumber2', $index) : null" />
                          </mat-form-field>
                          <div [id]="getFieldErrorId('npiNumber2')">
                            <cfi-form-inline-error [control]="detail.get('npiNumber2')" />
                          </div>
                        </div>
                      </div>
                    }
                    @if (employeeData().employeeType === therapyType) {
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'licenseNumber-' + $index" class="field-label">License Number</label>
                          <mat-form-field class="provider-fields">
                            <input [attr.id]="'licenseNumber-' + $index" matInput type="number" placeholder="1234567890"
                                   class="user-record-field-input" formControlName="licenseNumber"
                                   [attr.aria-describedby]="detail.get('licenseNumber')?.invalid && detail.get('licenseNumber')?.touched ? getFieldErrorId('licenseNumber', $index) : null" />
                          </mat-form-field>
                          <div [id]="getFieldErrorId('licenseNumber')">
                            <cfi-form-inline-error [control]="detail.get('licenseNumber')" />
                          </div>
                        </div>
                      </div>
                      <div class="employees__input-field quarter-width">
                        <div class="user-record-field-wrapper">
                          <label [attr.for]="'stateCtrl-' + $index" class="field-label">Issuing State</label>
                          <mat-form-field class="provider-fields">
                            <input #issuingStateInputTrigger="matAutocompleteTrigger" [attr.id]="'stateCtrl-' + $index" matInput
                                   type="text" placeholder="Example: North Carolina" class="user-record-field-input"
                                   formControlName="stateCtrl" readonly (click)="issuingStateInputTrigger.openPanel()"
                                   [matAutocomplete]="stateAuto"
                                   [attr.aria-describedby]="detail.get('stateCtrl')?.invalid && detail.get('stateCtrl')?.touched ? getFieldErrorId('stateCtrl', $index) : null" />
                            <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayState">
                              @for (state of filteredStates | async; track state.code) {
                                <mat-option [value]="state">
                                  {{state.name}}
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                          <div [id]="getFieldErrorId('stateCtrl')">
                            <cfi-form-inline-error [control]="detail.get('stateCtrl')" />
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <div class="employees__footer-button-container">
              <button mat-stroked-button class="employees__deactivate-button" type="button"
                      (click)="selectedId ? onCancelClick() : onBackClick()">
                Back
              </button>
              @if (!viewOnly) {
                <button mat-raised-button color="primary" class="employees__header-button" type="submit"
                        [disabled]="employeeForm.invalid || loading()">
                  Save
                </button>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</form>